// Debounce a changing value. The displayed input stays synchronous; only the
// downstream value (filter, search, fetch) lags by `delayMs` (D-24: 350 ms).
import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, delayMs = 350): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
